import { createContext } from "react";

type LoginModalContext = {
  inModal: boolean;
}
const LoginModalContext = createContext<LoginModalContext>({ inModal: false });

export default LoginModalContext;
